import PropTypes from 'prop-types'

import HBox from './HBox'
import { TextField } from './InputField'
import i18n from '@/i18n'

export function CopyrightField({
  letter,
  locked,
  defaultYear,
  defaultName,
  onYearChange,
  onNameChange,
  ...props
}) {

  return (
    <HBox {...props}>
      <TextField
        variant="plain"
        type="number"
        locked={locked}
        label={`${letter} ${i18n.t('year')}`}
        placeholder={i18n.t('year')}
        defaultValue={defaultYear}
        onChange={(event) => { onYearChange(event.target.value) }}
      />
      <TextField
        variant="plain"
        sx={{ flex: 1 }}
        type="text"
        locked={locked}
        label={`${letter} ${i18n.t('text')}`}
        placeholder={i18n.t('text')}
        defaultValue={defaultName}
        onChange={(event) => { onNameChange(event.target.value) }}
      />
    </HBox>
  )
}

CopyrightField.propTypes = {
  letter: PropTypes.string,
  locked: PropTypes.bool,
  defaultYear: PropTypes.number,
  defaultName: PropTypes.string,
  onYearChange: PropTypes.func,
  onNameChange: PropTypes.func
}